import "./instrument";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./i18n";
import { makeTheme } from "bootstrap-styled/lib/theme";
import BootstrapProvider from "@bootstrap-styled/provider/lib/BootstrapProvider";
import bootstrapTheme from "Theme/bootstrap";
import { history, store } from "./store";
import App from "./containers/App";
import { VERSION } from "./config";
import ErrorBoundary from "./containers/ErrorBoundary";
import * as Sentry from "@sentry/react";

const ssgTheme = makeTheme(bootstrapTheme);

window.SRS_VERSION = VERSION;

window.getSRSVersionURL = function(hash) {
  return `https://github.com/isolary/srs/commit/${hash}`;
};

const render = App => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <Sentry.ErrorBoundary fallback={<ErrorBoundary />}>
          <BootstrapProvider theme={ssgTheme}>
            <App history={history} />
          </BootstrapProvider>
        </Sentry.ErrorBoundary>
      </Provider>
    </React.StrictMode>,
    document.getElementById("root")
  );
};

render(App);
